import Button from "../../../../components/ui/Button";
import Modal, { ModalBody, ModalFooter, ModalFooterChild, ModalHeader } from "../../../../components/ui/Modal";

const RemoveWatchListConfirmationModel = ({ modalStatus, setModalStatus, handleRemoveWatchList, isLoading }) => {
  return (
    <>
      <Modal
        isOpen={modalStatus}
        setIsOpen={setModalStatus}
        isAnimation={true}
        isCentered={true}
        isScrollable={true}
        isStaticBackdrop={"rounded-3xl"}
        size={"sm"}
      >
        <ModalHeader>Remove from Watchlist?</ModalHeader>
        <ModalBody>
          Are you sure you want to remove this item from your watchlist? This action cannot be undone. Click OK to
          confirm.
        </ModalBody>

        <ModalFooter className="mt-[20px]">
          <ModalFooterChild></ModalFooterChild>
          <ModalFooterChild>
            <Button
              onClick={() => setModalStatus(false)}
              className="cursor-pointer flex items-center !text-white text-[16px] !bg-[#cb3b41]"
            >
              Not Now
            </Button>
            <Button
              onClick={() => handleRemoveWatchList()}
              className="cursor-pointer flex items-center !text-black text-[16px] !bg-[#FEBA06]"
            >
              {isLoading ? "loading..." : "Ok"}
            </Button>
          </ModalFooterChild>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default RemoveWatchListConfirmationModel;
